import React, { useEffect, createElement } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function CheckoutSection() {
  useEffect(() => {
    // Load Hotmart checkout widget script
    const script = document.createElement('script');
    script.src = 'https://static.hotmart.com/checkout/widget.min.js';
    script.type = 'text/javascript';
    document.head.appendChild(script);
    // Load Hotmart checkout widget CSS
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = 'https://static.hotmart.com/css/hotmart-fb.min.css';
    document.head.appendChild(link);
    return () => {
      document.head.removeChild(script);
      document.head.removeChild(link);
    };
  }, []);
  return <section id="checkout" className="bg-emerald-deep text-white py-12 md:py-16 px-4 relative overflow-hidden dna-pattern" data-id="element-37">
      <div className="absolute inset-0 bg-gradient-to-t from-emerald-deep to-emerald-deep/80 z-0" data-id="element-38"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-39">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-40">
          <h2 className="text-3xl md:text-5xl font-display font-bold text-gold mb-6" data-id="element-41">
            ¿Vas a seguir cargando esa mochila de 20kg de cansancio? 🎒
          </h2>
          <p className="text-lg md:text-xl text-warm-white/90 font-body max-w-2xl mx-auto mb-8" data-id="element-42">
            Cada día que esperas, el incendio interno crece. Tienes dos caminos:
            Seguir igual o probar el Reinicio sin riesgo.
          </p>

          <div className="bg-emerald-dark/60 border border-gold/20 rounded-xl p-6 inline-flex items-center gap-4 max-w-2xl mx-auto text-left backdrop-blur-sm mb-12" data-id="element-43">
            <ShieldCheck className="w-12 h-12 text-gold flex-shrink-0" data-id="element-44" />
            <div data-id="element-45">
              <h4 className="font-bold text-gold text-lg mb-1" data-id="element-46">
                GARANTÍA ZEKLO
              </h4>
              <p className="text-sm text-warm-white/80" data-id="element-47">
                Pruébalo 7 días. Si no sientes la ligereza, te devolvemos el
                100%.
              </p>
            </div>
          </div>
        </motion.div>

        {/* Hotmart Checkout Widget */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="text-center" data-id="element-48">
          <a onClick={() => {
          if (typeof window !== 'undefined' && (window as any).fbq) {
            ;
            (window as any).fbq('track', 'AddToCart', {
              value: 26.0,
              currency: 'EUR'
            });
          }
          return false;
        }} href="https://pay.hotmart.com/W104988940M?checkoutMode=2" className="hotmart-fb hotmart__button-checkout inline-block cta-pulse bg-gradient-to-r from-gold to-gold-bright text-emerald-deep font-bold py-5 px-10 rounded-full text-xl md:text-2xl shadow-lg hover:scale-105 transition-transform duration-300 no-underline cursor-pointer" data-id="element-49">
            👉 SÍ, QUIERO MI REINICIO — 26€
          </a>

          <p className="text-warm-white/60 text-sm mt-6 font-body" data-id="element-50">
            🔒 Pago 100% seguro a través de Hotmart
          </p>
        </motion.div>
      </div>
    </section>;
}